import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";

/**
 * Choose individual or organization signup.
 * @returns {JSX.Element}
 */
export default function CreateAccountPage() {
  return (
    <main className="min-h-screen bg-primary px-4 py-12 text-text-primary">
      <div className="mx-auto max-w-3xl">
        <h1 className="mb-3 text-center text-3xl font-bold">Create an account</h1>
        <p className="mb-10 text-center text-text-secondary">
          Are you signing up as an individual ministry leader or as an organization?
        </p>
        <div className="grid gap-6 md:grid-cols-2">
          <Card className="border-border bg-secondary">
            <CardHeader>
              <CardTitle className="text-xl text-text-primary">Individual</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-text-secondary">
                For pastors and ministry leaders applying on their own. Your account is reviewed by
                our team before you can use the platform.
              </p>
              <Button asChild className="w-full">
                <Link to="/new-user">Continue as individual</Link>
              </Button>
            </CardContent>
          </Card>
          <Card className="border-border bg-secondary">
            <CardHeader>
              <CardTitle className="text-xl text-text-primary">Organization</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-text-secondary">
                For churches, ministries, and groups. Organization accounts are reviewed by our team
                before they become active.
              </p>
              <Button asChild className="w-full">
                <Link to="/new-org">Continue as organization</Link>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </main>
  );
}
